module.exports = __webpack_public_path__ + "static/img/2.87ac8f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/2.png
// module id = SR9b
// module chunks = 0